import React from 'react'
import RecommendedReads from '../../../shared/BrandPages/RecommendedReads'
import TestimonialsSlider from './TestimonialsSlider'
import HeroSection from '../../../shared/Rewrite/BrandPages/HeroSection'
import CheckList from './CheckList'
import BrandSection from '../../../shared/BrandPages/BrandSection'
import ColumnToRowSection from '../../../shared/BrandPages/ColumnToRowSection'
import VideoPlayer from 'src/components/shared/VideoPlayer'
import BlueSection from '../../../shared/BrandPages/BlueSection'
import { whoWeHelpData } from './consts'
import BottomSection from '../../../shared/BrandPages/BottomSection'
import styles from './index.module.scss'
import Section from '../../../shared/BrandPages/Section'
import Content from '../../../shared/BrandPages/Content'
import { jsonLdData } from '../../../../common/constants/jsonLd'
import CustomJsonLd from '../../../shared/CustomJsonLd'
import PropTypes from 'prop-types'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'

const WhoWeHelp = () => {
  const {
    heroData,
    testimonialsData,
    recommendedReadsData,
    financialSituationData,
    debtImpactData,
    blueSectionData,
    moveForwardData,
    bottomSectionData,
    debtReliefData,
    seo,
  } = whoWeHelpData

  // const { isDesktop } = useDeviceDetect()

  return (
    <Content>
      <WithSeoOverrides {...seo} />
      <CustomJsonLd
        id={'webPage'}
        data={jsonLdData(seo?.title, seo?.description, '/who-we-help/')}
      />
      <Section classNames="pt-0 pb-0 lg:pl-4 xl:pl-0">
        <HeroSection
          {...heroData}
          contentClassName={styles.contentClassName}
          overlayShadowClassName={styles.overlayShadow}
          heroContainerClassName={styles.heroClassName}
        />
      </Section>
      <Section classNames="bg-blue-base-white">
        <BrandSection
          {...financialSituationData}
          childClassName="order-3 flex justify-left lg:justify-center pt-9 lg:pb-13 lg:pt-18"
          wrapperClassName="mt-8 lg:mt-0"
        >
          <CheckList data={financialSituationData.checkList} />
        </BrandSection>
      </Section>
      <Section>
        <h3
          className="pb-8 text-center text-15 font-medium leading-5 text-blue-base lg:pb-12"
          id="path-to-freedom"
        >
          A path to freedom
        </h3>
        <div className="gap-x-primary padding-x-primary grid grid-cols-4 lg:grid-cols-12 lg:px-0">
          <div className="col-span-full lg:col-span-12 lg:col-start-2">
            <TestimonialsSlider {...testimonialsData} />
          </div>
        </div>
      </Section>
      <Section classNames="bg-blue-base-white">
        <BrandSection
          {...debtImpactData}
          childClassName="order-last w-content pt-[50px] px-6 lg:px-0"
        >
          <ColumnToRowSection
            data={debtImpactData.columnToRow}
            title={debtImpactData.title}
          />
        </BrandSection>
      </Section>
      <Section>
        <div className="gap-x-primary padding-x-primary grid grid-cols-4 lg:grid-cols-12">
          <div className="col-span-full pb-8 lg:col-span-8 lg:col-start-3 lg:pb-0">
            <BrandSection
              {...debtReliefData}
              descriptionClassname="order-3"
              childClassName="order-2 lg:order-last"
            >
              <div
                className="object-top px-0 py-5 lg:px-14 lg:pb-12 "
                id="video-player"
              >
                <VideoPlayer
                  url="https://www.youtube.com/watch?v=KKvrtN7rDPI&ab_channel=FreedomDebtRelief"
                  className={`h-48 w-full md:h-96 lg:h-116`}
                  light={
                    '/next-assets/brand-pages/who-we-help/video-image.webp'
                  }
                />
              </div>
            </BrandSection>
          </div>
        </div>
        <BlueSection {...blueSectionData} />
        <div className="pt-8 lg:pt-12">
          <BrandSection {...moveForwardData} />
        </div>
      </Section>
      <Section classNames="bg-blue-base-white">
        <RecommendedReads data={recommendedReadsData} />
      </Section>
      <Section classNames="pb-0 pt-0">
        <BottomSection {...bottomSectionData} />
      </Section>
    </Content>
  )
}

WhoWeHelp.defaultProps = {
  banner: {},
}

WhoWeHelp.propTypes = {
  banner: PropTypes.object,
}

export default WhoWeHelp
